import { NgModule } from '@angular/core';
import { SectionFooterComponent } from './section-footer.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    RouterModule
  ],
  declarations: [
    SectionFooterComponent
  ],
  exports: [
    SectionFooterComponent
  ]
})
export class SectionFooterModule { }
